import { Button, Checkbox, Dialog, DialogBody, DialogFooter, DialogProps, Intent } from '@blueprintjs/core'
import * as React from 'react'
import Client from '../../../client'
import APIErrorCallout from '../../../components/errors/APIErrorCallout'
import { getFromStorage, setInStorage } from '../../../storage'
import { showToast } from '../../../Toast'
import { S } from '../../../utils'

export interface PurgeDialogProps extends DialogProps {
  onClose: any
  data: any
  channelId: number
}

interface PurgeDialogState {
  loading: boolean
  error: Error
  alsoRecycleProduct: boolean
}

const LISTING_OPTION_RECYCLE_PRODUCT = 'LISTING_OPTION_RECYCLE_PRODUCT_KEY'

class PurgeDialog extends React.Component<PurgeDialogProps, PurgeDialogState> {
  constructor(props) {
    super(props)
    this.state = {
      loading: false,
      error: null,
      alsoRecycleProduct: !!getFromStorage(LISTING_OPTION_RECYCLE_PRODUCT, true)
    }
  }

  purge = async () => {
    const { data, channelId } = this.props
    const { alsoRecycleProduct } = this.state
    this.setState({ loading: true, error: null })
    try {
      const res = await Client.v5ListingsRecycle(data, channelId, alsoRecycleProduct)

      this.setState({ loading: false }, () => {
        showToast(`Recycling ${data.length} listing${S(data)}...`, Intent.PRIMARY)
        this.props.onClose(true, res.data.failedIds)
      })
    } catch (e) {
      this.setState({
        loading: false,
        error: e.response
      })
    }
  }

  onClose = () => {
    this.setState(
      {
        loading: false,
        error: null
      },
      () => this.props.onClose()
    )
  }

  setAlsoRecycleProduct = () => {
    this.setState(
      s => ({ alsoRecycleProduct: !s.alsoRecycleProduct }),
      () => setInStorage(LISTING_OPTION_RECYCLE_PRODUCT, this.state.alsoRecycleProduct, true)
    )
  }

  render() {
    const { isOpen, data } = this.props
    const { loading, error, alsoRecycleProduct } = this.state
    return (
      <Dialog isOpen={isOpen} onClose={this.onClose} title="Recycle">
        {error && <APIErrorCallout response={error} />}
        <DialogBody>
          These listing{S(data)} will move into the recycled tab. Optionally use the checkbox below to prepare the
          product to be purged.
          <p>
            <h4>Options</h4>

            <Checkbox checked={alsoRecycleProduct} onClick={this.setAlsoRecycleProduct}>
              Also recycle product (disables ability to relist)
            </Checkbox>
          </p>
        </DialogBody>
        <DialogFooter
          actions={
            <Button loading={loading} intent={Intent.PRIMARY} onClick={this.purge}>
              Recycle {data.length} listing{S(data)}
            </Button>
          }
        />
      </Dialog>
    )
  }
}

export default PurgeDialog
